import { arc as d3Arc } from 'd3-shape';
import { element } from '../../../core/elements';
import { ValueLabel } from '../../../primitives/label/label';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const DonutMarkLabels = element(function DonutMarkLabels(_ref) {
  let {
    arcs,
    hide
  } = _ref;
  if (hide) return null;
  const arcPath = d3Arc();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: arcs.map(arc => {
      const arcCentroid = arcPath.centroid({
        innerRadius: arc.innerRadius,
        outerRadius: arc.outerRadius,
        startAngle: arc.startAngle,
        endAngle: arc.endAngle
      });
      return /*#__PURE__*/_jsx(ValueLabel, {
        x: arcCentroid[0],
        y: arcCentroid[1],
        color: arc.fill,
        children: arc.value
      }, `stack-label-${arc.key}`);
    })
  });
});